const H = {
  name: "MachineLearning",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 8H8V16H16V8ZM10 14V10H14V14H10Z" fill="currentColor"/>
<path d="M9 0V3H11V0H13V3H15V0H17V3.10002C18.9591 3.4977 20.5023 5.04087 20.9 7H24V9H21V11H24V13H21V15H24V17H20.9C20.5023 18.9591 18.9591 20.5023 17 20.9V24H15V21H13V24H11V21H9V24H7V20.9C5.04087 20.5023 3.4977 18.9591 3.10002 17H0V15H3V13H0V11H3V9H0V7H3.10002C3.4977 5.04087 5.04087 3.4977 7 3.10002V0H9ZM5 16C5 17.6569 6.34315 19 8 19H16C17.6569 19 19 17.6569 19 16V8C19 6.34315 17.6569 5 16 5H8C6.34315 5 5 6.34315 5 8V16Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as MachineLearning
};
